import { updateShoppingSessionPersonalNutrition } from '@ori/global-api-client-react';
export async function addPersonalNutritionItems({
  client,
  globalShoppingPersonalNutritionComponentsDto,
  sessionId,
  tenant
}) {
  // TODO -- Is this needed when there is the tenant prop of ApiProvider applied on some upper level?
  const headers = {
    'x-tenant-context': tenant
  };
  return updateShoppingSessionPersonalNutrition(client, sessionId, globalShoppingPersonalNutritionComponentsDto, headers);
}
//# sourceMappingURL=addPersonalNutritionItems.js.map